import React from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <div className="scroll-smooth" data-id="element-0">
      <LandingPage data-id="element-1" />
    </div>;
}